import { t } from "i18next";
import { DataTableData } from "../../../../components/deprecated/DataTable/DataTable";
import { CompanyData } from "../../Company/CompanyData";
import { CompanyInvoiceReceiverData } from "../../Company/CompanyInvoiceReceiverData";
import { DataObjectHelper } from "../DataObjects/DataObjectHelper";
import { FirebaseDataCompanyField } from "../DataObjectField/CustomFields/FirebaseDataCompanyField";
import { FirebaseDataStringField } from "../DataObjectField/Generic/FirebaseDataStringField";

export class InvoiceReceiverDataHelper extends DataObjectHelper<CompanyInvoiceReceiverData> {
  id = () => "invoiceReceiver";

  displayName = () => t("main.invoiceReceiver");

  company = new FirebaseDataCompanyField<CompanyInvoiceReceiverData>("company", t("main.company"), (data) =>
    data.parent instanceof CompanyData ? data.parent : undefined
  );
  receiver = new FirebaseDataStringField<CompanyInvoiceReceiverData>("receiver", t("main.receiver"), (data) => data.receiver);
  address = new FirebaseDataStringField<CompanyInvoiceReceiverData>("address", t("main.address"), (data) => data.address);
  postBox = new FirebaseDataStringField<CompanyInvoiceReceiverData>("postBox", t("main.postBox"), (data) => data.postBox);
  postalCode = new FirebaseDataStringField<CompanyInvoiceReceiverData>("postalCode", t("main.postalCode"), (data) => data.postalCode);
  email = new FirebaseDataStringField<CompanyInvoiceReceiverData>("email", t("main.email"), (data) => data.email);
  reference = new FirebaseDataStringField<CompanyInvoiceReceiverData>("reference", t("main.reference"), (data) => data.reference);
  orgNumber = new FirebaseDataStringField<CompanyInvoiceReceiverData>("orgNumber", t("main.organizationNumber"), (data) => data.orgNumber);

  allFields() {
    return [this.company, this.receiver, this.address, this.postBox, this.postalCode, this.email, this.reference, this.orgNumber];
  }
  getAllDataTableDatas(documents: CompanyInvoiceReceiverData[]): DataTableData[] {
    return [];
  }
}

